<!--File: logged-out.template.html-->
<!--Author: Joseph M Diaz-->
<!--Date: 4/24/2017-->
<!--Desc: Template for the logged out page. -->
<!--Other Contributors:-->

<div class="alert alert-danger cgp-logout">
   <span i18n>
      You have been logged out.
   </span>
   <span i18n="Instructions on how to log back in with a hyperlink.">
      Please click <span class="hyperlink" (click)="logBackIn()">here</span> to log back in.
   </span>
</div>